export enum BulkAction {
  Enable = 'enable',
  Disable = 'disable',
}

export const BULK_ACTIONS = [
  {
    label: 'Set data sharing status to active',
    value: BulkAction.Enable,
  },
  {
    label: 'Set data sharing status to inactive',
    value: BulkAction.Disable,
  },
];
